export const MAX_EMAIL_LENGTH = 64;
export const MAX_USER_NAME_LENGTH = 30;
